import { atom } from "recoil";

// 새로고침 시에도 선택한 인물 및 학교 보존
const sessionStorageEffect = key => ({setSelf, onSet}) => {
    const savedValue = sessionStorage.getItem(key)
    if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
    }

    onSet((newValue, _, isReset) => {
        isReset ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, JSON.stringify(newValue));
    });
};

export const selectedPerson = atom({
    key: 'selectedPerson',
    default:  [],
    effects: [
        sessionStorageEffect('selectedPerson')
    ]
});

export const selectedPersonKept = atom({
    key: 'selectedPersonKept',
    default: [],
});

export const selectedSchool = atom({
    key: 'selectedSchool',
    default:  [],
    effects: [
        sessionStorageEffect('selectedSchool')
    ]
});


export const selectedColonicalBookId = atom({
    key: 'selectedColonicalBookId',
    default: null,
});

// 통계표 id
export const selectedColonicalTableauId = atom({
    key: 'selectedColonicalTableauId',
    default: null,
});

export const selectedColonicalBookInfo = atom({
    key: 'selectedColonicalBookInfo',
    default: null,
});



